export const CTA_TARGET_COURSERA_PLUS_CHECKOUT_PAGE = 'cplus-checkout-page';
